


// import React from "react";

// // ==========================================
// // Types & Interfaces
// // ==========================================

// interface Employee {
//   _id: string;
//   fullName: string;
//   username: string;
//   employeeType?: string | null;
//   availabilityStatus: "Available" | "Busy";
//   location: string;
//   groupMembers?: { _id?: string; name: string }[];
// }

// interface PieceWorkTask {
//   lotNumber: string;
//   segmentName: string;
//   pieces: number;
//   assignedAt: string | null;
//   completedAt: string | null;
//   workStatus?: string;
//   memberName?: string;
// }

// interface PieceWorkReportData {
//   employeeType: string;
//   summary: {
//     completed: number;
//     incomplete: number;
//     inProgress: number;
//     total: number;
//   };
//   tasks: PieceWorkTask[];
// }

// interface Props {
//   employee: Employee;
//   startDate: string;
//   endDate: string;
//   onStartDateChange: (value: string) => void;
//   onEndDateChange: (value: string) => void;
//   report: PieceWorkReportData | null;
//   reportLoading: boolean;
//   reportError: string | null;

//   // Advanced filters
//   lotFilter: string;
//   segmentFilter: string;
//   memberFilter: string;
//   statusFilter: "" | "completed" | "incomplete" | "in-progress";
//   assignedFrom: string;
//   assignedTo: string;
//   finishedFrom: string;
//   finishedTo: string;
//   onLotFilterChange: (value: string) => void;
//   onSegmentFilterChange: (value: string) => void;
//   onMemberFilterChange: (value: string) => void;
//   onStatusFilterChange: (value: "" | "completed" | "incomplete" | "in-progress") => void;
//   onAssignedFromChange: (value: string) => void;
//   onAssignedToChange: (value: string) => void;
//   onFinishedFromChange: (value: string) => void;
//   onFinishedToChange: (value: string) => void;
// }

// // ==========================================
// // Helper Functions
// // ==========================================

// const formatIST = (dateString: string | null): string => {
//   if (!dateString) return "-";
//   const d = new Date(dateString);
//   if (isNaN(d.getTime())) return "-";

//   return d.toLocaleString("en-IN", {
//     timeZone: "Asia/Kolkata",
//     day: "2-digit",
//     month: "short",
//     year: "numeric",
//     hour: "2-digit",
//     minute: "2-digit",
//     hour12: true,
//   });
// };

// const getRoleBadgeStyle = (type?: string | null) => {
//   switch (type) {
//     case "Master":
//       return "bg-indigo-50 text-indigo-700";
//     case "Karigar":
//       return "bg-emerald-50 text-emerald-700";
//     case "job-work":
//       return "bg-orange-50 text-orange-700";
//     default:
//       return "bg-pink-50 text-pink-700";
//   }
// };

// const getStatusBadge = (status?: string) => {
//   const s = status?.toLowerCase() || "";

//   if (s === "completed") {
//     return (
//       <span className="inline-flex items-center rounded-full border border-green-200 bg-green-50 px-2 py-0.5 text-[10px] font-semibold uppercase text-green-700">
//         Completed
//       </span>
//     );
//   }
//   if (s === "incomplete") {
//     return (
//       <span className="inline-flex items-center rounded-full border border-red-200 bg-red-50 px-2 py-0.5 text-[10px] font-semibold uppercase text-red-700">
//         Incomplete
//       </span>
//     );
//   }
//   // Default for In Progress
//   return (
//     <span className="inline-flex items-center rounded-full border border-blue-200 bg-blue-50 px-2 py-0.5 text-[10px] font-semibold uppercase text-blue-700">
//       In Progress
//     </span>
//   );
// };

// // ==========================================
// // Component
// // ==========================================

// const PieceWorkEmployeeDetail: React.FC<Props> = ({
//   employee,
//   startDate,
//   endDate,
//   onStartDateChange,
//   onEndDateChange,
//   report,
//   reportLoading,
//   reportError,

//   lotFilter,
//   segmentFilter,
//   memberFilter,
//   statusFilter,
//   assignedFrom,
//   assignedTo,
//   finishedFrom,
//   finishedTo,
//   onLotFilterChange,
//   onSegmentFilterChange,
//   onMemberFilterChange,
//   onStatusFilterChange,
//   onAssignedFromChange,
//   onAssignedToChange,
//   onFinishedFromChange,
//   onFinishedToChange,
// }) => {
//   const isGroupWorkSelected =
//     employee?.employeeType === "Group Work" ||
//     report?.employeeType === "Group Work";

//   return (
//     <div className="animate-fade-in pb-10">
//       {/* 1. Date Filters */}
//       <div className="mb-6 grid gap-3 rounded-xl bg-white p-4 shadow-sm md:grid-cols-2">
//         <div className="flex flex-col">
//           <label className="mb-1 text-xs font-medium text-gray-600">
//             Start Date
//           </label>
//           <input
//             type="date"
//             value={startDate}
//             onChange={(e) => onStartDateChange(e.target.value)}
//             className="rounded-md border border-gray-300 px-2 py-1.5 text-sm text-gray-800 shadow-sm focus:border-indigo-500 focus:outline-none"
//           />
//         </div>
//         <div className="flex flex-col">
//           <label className="mb-1 text-xs font-medium text-gray-600">
//             End Date
//           </label>
//           <input
//             type="date"
//             value={endDate}
//             onChange={(e) => onEndDateChange(e.target.value)}
//             className="rounded-md border border-gray-300 px-2 py-1.5 text-sm text-gray-800 shadow-sm focus:border-indigo-500 focus:outline-none"
//           />
//         </div>
//       </div>

//       <div className="mt-4 space-y-4">
//         <div className="grid gap-3 md:grid-cols-2 items-start">
//           {/* Employee Card — Compact */}
//           <div className="rounded-lg bg-white p-4 shadow-sm border border-gray-100">
//             <h2 className="text-lg font-semibold text-slate-900 leading-tight">
//               {employee.fullName}
//             </h2>

//             <p className="text-xs text-slate-500 mt-1">
//               {employee.username} • {employee.location}
//             </p>

//             <span
//               className={`mt-3 inline-flex items-center rounded-full px-2.5 py-[3px] text-[10px] font-medium ${getRoleBadgeStyle(
//                 employee.employeeType
//               )}`}
//             >
//               {employee.employeeType}
//             </span>
//           </div>

//           {/* Work Summary Card — Compact */}
//           <div className="rounded-lg bg-white p-4 shadow-sm border border-gray-100">
//             {/* Header */}
//             <div className="flex items-center justify-between mb-3">
//               <p className="text-[10px] font-semibold uppercase tracking-wide text-slate-500">
//                 Work Summary
//               </p>

//               {!reportLoading && (
//                 <span className="rounded-full bg-slate-50 px-2.5 py-[2px] text-[9px] font-medium text-slate-400">
//                   {startDate && endDate ? "Custom Range" : "All Time"}
//                 </span>
//               )}
//             </div>

//             {reportLoading ? (
//               <div className="py-6 text-center text-xs text-slate-400">
//                 Loading…
//               </div>
//             ) : (
//               <>
//                 {/* Total Completed */}
//                 <div className="text-center mb-3">
//                   <p className="text-[9px] font-semibold uppercase text-slate-500 tracking-wide">
//                     Total Completed
//                   </p>

//                   <p className="mt-1 text-3xl font-bold text-slate-900 leading-none">
//                     {report?.summary.completed ?? 0}
//                   </p>

//                   {startDate && endDate && (
//                     <p className="mt-1 inline-block rounded-full bg-slate-50 px-2.5 py-[1px] text-[9px] text-slate-500">
//                       {startDate} → {endDate}
//                     </p>
//                   )}
//                 </div>

//                 {/* Divider */}
//                 <div className="h-px bg-slate-100 my-2" />

//                 {/* Bottom Stats */}
//                 <div className="grid grid-cols-2 gap-3 text-center">
//                   <div>
//                     <p className="text-[9px] font-semibold uppercase text-slate-500 tracking-wide">
//                       Incomplete
//                     </p>
//                     <p className="text-lg font-bold text-rose-500 mt-1">
//                       {report?.summary.incomplete ?? 0}
//                     </p>
//                   </div>

//                   <div>
//                     <p className="text-[9px] font-semibold uppercase text-slate-500 tracking-wide">
//                       In Progress
//                     </p>
//                     <p className="text-lg font-bold text-sky-500 mt-1">
//                       {report?.summary.inProgress ?? 0}
//                     </p>
//                   </div>
//                 </div>
//               </>
//             )}
//           </div>
//         </div>

//         {reportError && (
//           <div className="rounded-xl border border-red-200 bg-red-50 p-3 text-sm text-red-700">
//             {reportError}
//           </div>
//         )}

//         {/* 3. Task History Table */}
//         <div className="overflow-hidden rounded-xl bg-white shadow-sm border border-gray-100">
//           <div className="overflow-x-auto">
//             <table className="min-w-full divide-y divide-gray-200 text-sm">
//               <thead className="bg-gray-50">
//                 {/* Header labels */}
//                 <tr>
//                   <th className="px-4 py-3 text-left text-xs font-bold uppercase tracking-wider text-gray-500">
//                     Lot Number
//                   </th>
//                   <th className="px-4 py-3 text-left text-xs font-bold uppercase tracking-wider text-gray-500">
//                     Segment
//                   </th>
//                   {isGroupWorkSelected && (
//                     <th className="px-4 py-3 text-left text-xs font-bold uppercase tracking-wider text-gray-500">
//                       Member
//                     </th>
//                   )}
//                   <th className="px-4 py-3 text-right text-xs font-bold uppercase tracking-wider text-gray-500">
//                     Pieces
//                   </th>
//                   <th className="px-4 py-3 text-left text-xs font-bold uppercase tracking-wider text-gray-500">
//                     Assigned Time
//                   </th>
//                   <th className="px-4 py-3 text-left text-xs font-bold uppercase tracking-wider text-gray-500">
//                     Finished Time
//                   </th>
//                   <th className="px-4 py-3 text-center text-xs font-bold uppercase tracking-wider text-gray-500">
//                     Status
//                   </th>
//                 </tr>

//                 {/* Filter row */}
//                 <tr className="bg-white border-t border-gray-200">
//                   {/* Lot filter */}
//                   <th className="px-4 py-2">
//                     <input
//                       type="text"
//                       value={lotFilter}
//                       onChange={(e) => onLotFilterChange(e.target.value)}
//                       placeholder="LOT0001..."
//                       className="w-full rounded-md border border-gray-200 px-2 py-1 text-xs focus:border-indigo-500 focus:outline-none"
//                     />
//                   </th>

//                   {/* Segment filter */}
//                   <th className="px-4 py-2">
//                     <input
//                       type="text"
//                       value={segmentFilter}
//                       onChange={(e) => onSegmentFilterChange(e.target.value)}
//                       placeholder="Segment"
//                       className="w-full rounded-md border border-gray-200 px-2 py-1 text-xs focus:border-indigo-500 focus:outline-none"
//                     />
//                   </th>

//                   {/* Member filter (only for Group Work) */}
//                   {isGroupWorkSelected && (
//                     <th className="px-4 py-2">
//                       <select
//                         value={memberFilter}
//                         onChange={(e) => onMemberFilterChange(e.target.value)}
//                         className="w-full rounded-md border border-gray-200 px-2 py-1 text-xs focus:border-indigo-500 focus:outline-none"
//                       >
//                         <option value="">All Members</option>
//                         {employee.groupMembers?.map((gm) => (
//                           <option key={gm._id || gm.name} value={gm._id}>
//                             {gm.name}
//                           </option>
//                         ))}
//                       </select>
//                     </th>
//                   )}

//                   {/* Pieces – no filter */}
//                   <th className="px-4 py-2" />

//                   {/* Assigned time range */}
//                   <th className="px-4 py-2">
//                     <div className="flex flex-col gap-1">
//                       <input
//                         type="date"
//                         value={assignedFrom}
//                         onChange={(e) => onAssignedFromChange(e.target.value)}
//                         className="w-full rounded-md border border-gray-200 px-2 py-1 text-[11px] focus:border-indigo-500 focus:outline-none"
//                       />
//                       <input
//                         type="date"
//                         value={assignedTo}
//                         onChange={(e) => onAssignedToChange(e.target.value)}
//                         className="w-full rounded-md border border-gray-200 px-2 py-1 text-[11px] focus:border-indigo-500 focus:outline-none"
//                       />
//                     </div>
//                   </th>

//                   {/* Finished time range */}
//                   <th className="px-4 py-2">
//                     <div className="flex flex-col gap-1">
//                       <input
//                         type="date"
//                         value={finishedFrom}
//                         onChange={(e) => onFinishedFromChange(e.target.value)}
//                         className="w-full rounded-md border border-gray-200 px-2 py-1 text-[11px] focus:border-indigo-500 focus:outline-none"
//                       />
//                       <input
//                         type="date"
//                         value={finishedTo}
//                         onChange={(e) => onFinishedToChange(e.target.value)}
//                         className="w-full rounded-md border border-gray-200 px-2 py-1 text-[11px] focus:border-indigo-500 focus:outline-none"
//                       />
//                     </div>
//                   </th>

//                   {/* Status filter */}
//                   <th className="px-4 py-2 text-center">
//                     <select
//                       value={statusFilter}
//                       onChange={(e) =>
//                         onStatusFilterChange(
//                           e.target.value as
//                             | ""
//                             | "completed"
//                             | "incomplete"
//                             | "in-progress"
//                         )
//                       }
//                       className="w-full rounded-md border border-gray-200 px-2 py-1 text-xs focus:border-indigo-500 focus:outline-none"
//                     >
//                       <option value="">All</option>
//                       <option value="completed">Completed</option>
//                       <option value="incomplete">Incomplete</option>
//                       <option value="in-progress">In Progress</option>
//                     </select>
//                   </th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-gray-100 bg-white">
//                 {reportLoading && (
//                   <tr>
//                     <td
//                       colSpan={isGroupWorkSelected ? 7 : 6}
//                       className="px-4 py-8 text-center text-xs text-gray-500"
//                     >
//                       Loading history...
//                     </td>
//                   </tr>
//                 )}

//                 {!reportLoading && report?.tasks.length === 0 && (
//                   <tr>
//                     <td
//                       colSpan={isGroupWorkSelected ? 7 : 6}
//                       className="px-4 py-8 text-center text-xs text-gray-500"
//                     >
//                       No work records found.
//                     </td>
//                   </tr>
//                 )}

//                 {!reportLoading &&
//                   report?.tasks.map((task, idx) => (
//                     <tr
//                       key={`${task.lotNumber}-${idx}`}
//                       className="hover:bg-gray-50 transition-colors"
//                     >
//                       <td className="px-4 py-3 text-xs font-medium text-gray-900">
//                         {task.lotNumber}
//                       </td>
//                       <td className="px-4 py-3 text-xs text-gray-600">
//                         {task.segmentName || "N/A"}
//                       </td>
//                       {isGroupWorkSelected && (
//                         <td className="px-4 py-3 text-xs text-gray-600">
//                           {task.memberName || "-"}
//                         </td>
//                       )}
//                       <td className="px-4 py-3 text-right text-xs font-bold text-gray-800">
//                         {task.pieces}
//                       </td>
//                       <td className="px-4 py-3 text-xs text-gray-500">
//                         {formatIST(task.assignedAt)}
//                       </td>
//                       <td className="px-4 py-3 text-xs text-gray-500">
//                         {formatIST(task.completedAt)}
//                       </td>
//                       <td className="px-4 py-3 text-center">
//                         {getStatusBadge(task.workStatus)}
//                       </td>
//                     </tr>
//                   ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PieceWorkEmployeeDetail;



import React, { useEffect, useState } from "react";
import axiosApi from "../server/service";

// ==========================================
// Types & Interfaces
// ==========================================

interface Employee {
  _id: string;
  fullName: string;
  username: string;
  employeeType?: string | null;
  availabilityStatus: "Available" | "Busy";
  location: string;
  groupMembers?: { _id?: string; name: string }[];
}

interface PieceWorkTask {
  lotNumber: string;
  segmentName: string;
  pieces: number;
  assignedAt: string | null;
  completedAt: string | null;
  workStatus?: string;
  memberName?: string;


  completionSteps?: {
    fabric?: boolean;
    astar?: boolean;
    embroidery?: boolean;
  };

}

interface PieceWorkReportData {
  employeeType: string;
  summary: {
    completed: number;
    incomplete: number;
    inProgress: number;
    total: number;
  };
  tasks: PieceWorkTask[];
}

interface Props {
  employee: Employee;
  startDate: string;
  endDate: string;
  onStartDateChange: (value: string) => void;
  onEndDateChange: (value: string) => void;
  report: PieceWorkReportData | null;
  reportLoading: boolean;
  reportError: string | null;

  // Advanced filters
  lotFilter: string;
  segmentFilter: string;
  memberFilter: string;
  statusFilter: "" | "completed" | "incomplete" | "in-progress";
  assignedFrom: string;
  assignedTo: string;
  finishedFrom: string;
  finishedTo: string;
  onLotFilterChange: (value: string) => void;
  onSegmentFilterChange: (value: string) => void;
  onMemberFilterChange: (value: string) => void;
  onStatusFilterChange: (
    value: "" | "completed" | "incomplete" | "in-progress"
  ) => void;
  onAssignedFromChange: (value: string) => void;
  onAssignedToChange: (value: string) => void;
  onFinishedFromChange: (value: string) => void;
  onFinishedToChange: (value: string) => void;


  onClearFilters: () => void;
}

// ==========================================
// Helper Functions
// ==========================================

const formatIST = (dateString: string | null): string => {
  if (!dateString) return "-";
  const d = new Date(dateString);
  if (isNaN(d.getTime())) return "-";

  return d.toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

const getRoleBadgeStyle = (type?: string | null) => {
  switch (type) {
    case "Master":
      return "bg-indigo-50 text-indigo-700";
    case "Karigar":
      return "bg-emerald-50 text-emerald-700";
    case "job-work":
      return "bg-orange-50 text-orange-700";
    default:
      return "bg-pink-50 text-pink-700";
  }
};

const getStatusBadge = (status?: string) => {
  const s = status?.toLowerCase() || "";

  if (s === "completed") {
    return (
      <span className="inline-flex items-center rounded-full border border-green-200 bg-green-50 px-2 py-0.5 text-[10px] font-semibold uppercase text-green-700">
        Completed
      </span>
    );
  }
  if (s === "incomplete") {
    return (
      <span className="inline-flex items-center rounded-full border border-red-200 bg-red-50 px-2 py-0.5 text-[10px] font-semibold uppercase text-red-700">
        Incomplete
      </span>
    );
  }
  // Default for In Progress
  return (
    <span className="inline-flex items-center rounded-full border border-blue-200 bg-blue-50 px-2 py-0.5 text-[10px] font-semibold uppercase text-blue-700">
      In Progress
    </span>
  );
};

// ==========================================
// Component
// ==========================================

const PieceWorkEmployeeDetail: React.FC<Props> = ({
  employee,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  report,
  reportLoading,
  reportError,

  lotFilter,
  segmentFilter,
  memberFilter,
  statusFilter,
  assignedFrom,
  assignedTo,
  finishedFrom,
  finishedTo,
  onLotFilterChange,
  onSegmentFilterChange,
  onMemberFilterChange,
  onStatusFilterChange,
  onAssignedFromChange,
  onAssignedToChange,
  onFinishedFromChange,
  onFinishedToChange,

  onClearFilters,
}) => {
  const isGroupWorkSelected =
    employee?.employeeType === "Group Work" ||
    report?.employeeType === "Group Work";

  const isMasterSelected =
    employee?.employeeType === "Master" || report?.employeeType === "Master";

  const totalColumns = isGroupWorkSelected
    ? 7
    : isMasterSelected
      ? 7
      : 6;

  const [lotOptions, setLotOptions] = useState<string[]>([]);
  const [segmentOptions, setSegmentOptions] = useState<string[]>([]);
  const [showLotDropdown, setShowLotDropdown] = useState(false);
  const [showSegmentDropdown, setShowSegmentDropdown] = useState(false);


  useEffect(() => {

    axiosApi
      .get("/api/dashboard/piece-work-filter-options")
      .then((res) => {
        if (res.data?.success) {
          setLotOptions(res.data.lots || []);
          setSegmentOptions(res.data.segments || []);
        }
      })
      .catch(() => { });
  }, []);


  console.log(report)

const renderStepRow = (label: string, done?: boolean) => {
  const isDone = done === true;

  return (
    <div className="flex items-center justify-between w-full text-[10px]">
      {/* Step */}
      <span className="px-1.5 py-0.5 rounded-md bg-gray-100 text-gray-700 border border-gray-200">
        {label}
      </span>

      {/* Status */}
      <span
        className={`px-1.5 py-0.5 rounded-md border ${
          isDone
            ? "bg-green-50 border-green-200 text-green-600"
            : "bg-red-50 border-red-200 text-red-600"
        }`}
      >
        {isDone ? "Done" : "Incomplete"}
      </span>
    </div>
  );
};





  return (
    <div className="animate-fade-in pb-10">
      {/* 1. Date Filters */}
      <div className="mb-6 grid gap-3 rounded-xl bg-white p-4 shadow-sm md:grid-cols-2">
        <div className="flex flex-col">
          <label className="mb-1 text-xs font-medium text-gray-600">
            Start Date
          </label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => onStartDateChange(e.target.value)}
            className="rounded-md border border-gray-300 px-2 py-1.5 text-sm text-gray-800 shadow-sm focus:border-indigo-500 focus:outline-none"
          />
        </div>
        <div className="flex flex-col">
          <label className="mb-1 text-xs font-medium text-gray-600">
            End Date
          </label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => onEndDateChange(e.target.value)}
            className="rounded-md border border-gray-300 px-2 py-1.5 text-sm text-gray-800 shadow-sm focus:border-indigo-500 focus:outline-none"
          />
        </div>
      </div>

      <div className="mt-4 space-y-4">
        <div className="grid gap-3 md:grid-cols-2 items-start">
          {/* Employee Card — Compact */}
          <div className="rounded-lg bg-white p-4 shadow-sm border border-gray-100">
            <h2 className="text-lg font-semibold text-slate-900 leading-tight">
              {employee.fullName}
            </h2>

            <p className="text-xs text-slate-500 mt-1">
              {employee.username} • {employee.location}
            </p>

            <span
              className={`mt-3 inline-flex items-center rounded-full px-2.5 py-[3px] text-[10px] font-medium ${getRoleBadgeStyle(
                employee.employeeType
              )}`}
            >
              {employee.employeeType}
            </span>
          </div>

          {/* Work Summary Card — Compact */}
          <div className="rounded-lg bg-white p-4 shadow-sm border border-gray-100">
            {/* Header */}
            <div className="flex items-center justify-between mb-3">
              <p className="text-[10px] font-semibold uppercase tracking-wide text-slate-500">
                Work Summary
              </p>

              {!reportLoading && (
                <span className="rounded-full bg-slate-50 px-2.5 py-[2px] text-[9px] font-medium text-slate-400">
                  {startDate && endDate ? "Custom Range" : "All Time"}
                </span>
              )}
            </div>

            {reportLoading ? (
              <div className="py-6 text-center text-xs text-slate-400">
                Loading…
              </div>
            ) : (
              <>
                {/* Total Completed */}
                <div className="text-center mb-3">
                  <p className="text-[9px] font-semibold uppercase text-slate-500 tracking-wide">
                    Total Completed
                  </p>

                  <p className="mt-1 text-3xl font-bold text-slate-900 leading-none">
                    {report?.summary.completed ?? 0}
                  </p>

                  {startDate && endDate && (
                    <p className="mt-1 inline-block rounded-full bg-slate-50 px-2.5 py-[1px] text-[9px] text-slate-500">
                      {startDate} → {endDate}
                    </p>
                  )}
                </div>

                {/* Divider */}
                <div className="h-px bg-slate-100 my-2" />

                {/* Bottom Stats */}
                <div className="grid grid-cols-2 gap-3 text-center">
                  <div>
                    <p className="text-[9px] font-semibold uppercase text-slate-500 tracking-wide">
                      Incomplete
                    </p>
                    <p className="text-lg font-bold text-rose-500 mt-1">
                      {report?.summary.incomplete ?? 0}
                    </p>
                  </div>

                  <div>
                    <p className="text-[9px] font-semibold uppercase text-slate-500 tracking-wide">
                      In Progress
                    </p>
                    <p className="text-lg font-bold text-sky-500 mt-1">
                      {report?.summary.inProgress ?? 0}
                    </p>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>

        {reportError && (
          <div className="rounded-xl border border-red-200 bg-red-50 p-3 text-sm text-red-700">
            {reportError}
          </div>
        )}

        {/* 3. Task History Table */}
        <div className="overflow-hidden rounded-xl bg-white shadow-sm border border-gray-100">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200 text-sm">
              <thead className="bg-gray-50">
                {/* Header labels */}
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-bold uppercase tracking-wider text-gray-500">
                    Lot Number
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-bold uppercase tracking-wider text-gray-500">
                    Segment
                  </th>
                  {isGroupWorkSelected && (
                    <th className="px-4 py-3 text-left text-xs font-bold uppercase tracking-wider text-gray-500">
                      Member
                    </th>
                  )}
                  <th className="px-4 py-3 text-right text-xs font-bold uppercase tracking-wider text-gray-500">
                    Pieces
                  </th>

                  {isMasterSelected && (
                    <th className="px-4 py-3 text-left text-xs font-bold uppercase tracking-wider text-gray-500">
                      Steps
                    </th>
                  )}

                  <th className="px-4 py-3 text-left text-xs font-bold uppercase tracking-wider text-gray-500">
                    Assigned Time
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-bold uppercase tracking-wider text-gray-500">
                    Finished Time
                  </th>
                  <th className="px-4 py-3 text-center text-xs font-bold uppercase tracking-wider text-gray-500">
                    Status
                  </th>
                </tr>

                {/* Filter row */}
                <tr className="bg-white border-t border-gray-200">
                  {/* Lot filter */}
                  {/* <th className="px-4 py-2">

                    <div className="relative">
                      <input
                        type="text"
                        value={lotFilter}
                        onChange={(e) => onLotFilterChange(e.target.value)}
                        placeholder="LOT0001..."
                        className="w-full rounded-md border border-gray-200 px-2 py-1 text-xs focus:border-indigo-500 focus:outline-none"
                        onFocus={() => setShowLotDropdown(true)}
                        onBlur={() =>
                          setTimeout(() => setShowLotDropdown(false), 150)
                        }
                      />
                      {showLotDropdown && lotOptions.length > 0 && (
                        <div className="absolute z-20 mt-1 max-h-40 w-full overflow-y-auto rounded-md border bg-white shadow">
                          {lotOptions
                            .filter((l) =>
                              l
                                ?.toString()
                                .toLowerCase()
                                .includes(lotFilter.toLowerCase())
                            )
                            .map((l) => (
                              <button
                                key={l}
                                type="button"
                                className="block w-full px-2 py-1 text-left text-xs hover:bg-gray-100"
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => {
                                  onLotFilterChange(l);
                                  setShowLotDropdown(false);
                                }}
                              >
                                {l}
                              </button>
                            ))}
                        </div>
                      )}
                    </div>

                  </th> */}
                  {/* Lot filter */}
                  <th className="px-4 py-2">
                    <div className="relative">
                      <input
                        type="text"
                        value={lotFilter}
                        onChange={(e) => {
                          onLotFilterChange(e.target.value);
                          setShowLotDropdown(true);
                        }}
                        placeholder="LOT0001..."
                        className="w-full rounded-md border border-gray-200 px-2 py-1 text-xs focus:border-indigo-500 focus:outline-none"
                        onFocus={() => setShowLotDropdown(true)}
                        onBlur={() => {

                          setTimeout(() => setShowLotDropdown(false), 150);
                        }}
                      />

                      {showLotDropdown && lotOptions.length > 0 && (
                        <div
                          className="absolute z-20 mt-1 max-h-40 w-full overflow-y-auto rounded-md border bg-white shadow"
                        >
                          {lotOptions
                            .filter((l) =>
                              l?.toString().toLowerCase().includes(lotFilter.toLowerCase())
                            )
                            .map((l) => (
                              <button
                                key={l}
                                type="button"
                                className="block w-full px-2 py-1 text-left text-xs hover:bg-gray-100"
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => {
                                  onLotFilterChange(l);
                                  setShowLotDropdown(false);
                                }}
                              >
                                {l}
                              </button>
                            ))}
                        </div>
                      )}
                    </div>
                  </th>


                  {/* Segment filter */}
                  {/* <th className="px-4 py-2">
                    <div className="relative"> 
                    <input
                      type="text"
                      value={segmentFilter}
                      onChange={(e) => onSegmentFilterChange(e.target.value)}
                      placeholder="Segment"
                      className="w-full rounded-md border border-gray-200 px-2 py-1 text-xs focus:border-indigo-500 focus:outline-none"
                      onFocus={() => setShowSegmentDropdown(true)}        
                        onBlur={() =>
                          setTimeout(() => setShowSegmentDropdown(false), 150)
                        }  
                    />
                    {showSegmentDropdown && segmentOptions.length > 0 && ( 
                        <div className="absolute z-20 mt-1 max-h-40 w-full overflow-y-auto rounded-md border bg-white shadow">
                          {segmentOptions
                            .filter((s) =>
                              s
                                ?.toString()
                                .toLowerCase()
                                .includes(segmentFilter.toLowerCase())
                            )
                            .map((s) => (
                              <button
                                key={s}
                                type="button"
                                className="block w-full px-2 py-1 text-left text-xs hover:bg-gray-100"
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => {
                                  onSegmentFilterChange(s);
                                  setShowSegmentDropdown(false);
                                }}
                              >
                                {s}
                              </button>
                            ))}
                        </div>
                      )}
                    </div>
                  </th> */}
                  {/* Segment filter */}
                  <th className="px-4 py-2">
                    <div className="relative">
                      <input
                        type="text"
                        value={segmentFilter}
                        onChange={(e) => {
                          onSegmentFilterChange(e.target.value);
                          setShowSegmentDropdown(true);
                        }}
                        placeholder="Segment"
                        className="w-full rounded-md border border-gray-200 px-2 py-1 text-xs focus:border-indigo-500 focus:outline-none"
                        onFocus={() => setShowSegmentDropdown(true)}
                        onBlur={() => {
                          setTimeout(() => setShowSegmentDropdown(false), 150);
                        }}
                      />

                      {showSegmentDropdown && segmentOptions.length > 0 && (
                        <div
                          className="absolute z-20 mt-1 max-h-40 w-full overflow-y-auto rounded-md border bg-white shadow"
                        >
                          {segmentOptions
                            .filter((s) =>
                              s?.toString().toLowerCase().includes(segmentFilter.toLowerCase())
                            )
                            .map((s) => (
                              <button
                                key={s}
                                type="button"
                                className="block w-full px-2 py-1 text-left text-xs hover:bg-gray-100"
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => {
                                  onSegmentFilterChange(s);
                                  setShowSegmentDropdown(false);
                                }}
                              >
                                {s}
                              </button>
                            ))}
                        </div>
                      )}
                    </div>
                  </th>


                  {/* Member filter (only for Group Work) */}
                  {isGroupWorkSelected && (
                    <th className="px-4 py-2">

                      <select
                        value={memberFilter}
                        onChange={(e) => onMemberFilterChange(e.target.value)}
                        className="w-full rounded-md border border-gray-200 px-2 py-1 text-xs focus:border-indigo-500 focus:outline-none"
                      >
                        <option value="">All Members</option>
                        {employee.groupMembers?.map((gm) => (
                          <option key={gm._id || gm.name} value={gm._id}>
                            {gm.name}
                          </option>
                        ))}
                      </select>
                    </th>
                  )}

                  {/* Pieces – no filter */}
                  <th className="px-4 py-2" />
                  {isMasterSelected && (
                    <th className="px-4 py-2" />
                  )}

                  {/* Assigned time range */}
                  <th className="px-4 py-2">
                    <div className="flex flex-col gap-1">
                      <input
                        type="date"
                        value={assignedFrom}
                        onChange={(e) => onAssignedFromChange(e.target.value)}
                        className="w-full rounded-md border border-gray-200 px-2 py-1 text-[11px] focus:border-indigo-500 focus:outline-none"
                      />
                      <input
                        type="date"
                        value={assignedTo}
                        onChange={(e) => onAssignedToChange(e.target.value)}
                        className="w-full rounded-md border border-gray-200 px-2 py-1 text-[11px] focus:border-indigo-500 focus:outline-none"
                      />
                    </div>
                  </th>

                  {/* Finished time range */}
                  <th className="px-4 py-2">
                    <div className="flex flex-col gap-1">
                      <input
                        type="date"
                        value={finishedFrom}
                        onChange={(e) => onFinishedFromChange(e.target.value)}
                        className="w-full rounded-md border border-gray-200 px-2 py-1 text-[11px] focus:border-indigo-500 focus:outline-none"
                      />
                      <input
                        type="date"
                        value={finishedTo}
                        onChange={(e) => onFinishedToChange(e.target.value)}
                        className="w-full rounded-md border border-gray-200 px-2 py-1 text-[11px] focus:border-indigo-500 focus:outline-none"
                      />
                    </div>
                  </th>

                  {/* Status filter + CLEAR button */}
                  <th className="px-4 py-2">
                    <div className="flex items-center justify-center gap-2">
                      <select
                        value={statusFilter}
                        onChange={(e) =>
                          onStatusFilterChange(
                            e.target.value as
                            | ""
                            | "completed"
                            | "incomplete"
                            | "in-progress"
                          )
                        }
                        className="rounded-md border border-gray-200 px-2 py-1 text-xs focus:border-indigo-500 focus:outline-none"
                      >
                        <option value="">All</option>
                        <option value="completed">Completed</option>
                        <option value="incomplete">Incomplete</option>
                        <option value="in-progress">In Progress</option>
                      </select>

                      <button
                        type="button"
                        onClick={onClearFilters}
                        className="whitespace-nowrap rounded-md border border-gray-300 bg-white px-2 py-1 text-[10px] font-medium text-gray-500 hover:bg-gray-50"
                      >
                        Clear
                      </button>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100 bg-white">
                {reportLoading && (
                  <tr>
                    <td
                      // colSpan={isGroupWorkSelected ? 7 : 6}
                      colSpan={totalColumns}
                      className="px-4 py-8 text-center text-xs text-gray-500"
                    >
                      Loading history...
                    </td>
                  </tr>
                )}

                {!reportLoading && report?.tasks.length === 0 && (
                  <tr>
                    <td
                      // colSpan={isGroupWorkSelected ? 7 : 6}
                      colSpan={totalColumns}
                      className="px-4 py-8 text-center text-xs text-gray-500"
                    >
                      No work records found.
                    </td>
                  </tr>
                )}

                {!reportLoading &&
                  report?.tasks.map((task, idx) => (
                    <tr
                      key={`${task.lotNumber}-${idx}`}
                      className="hover:bg-gray-50 transition-colors"
                    >
                      <td className="px-4 py-3 text-xs font-medium text-gray-900">
                        {task.lotNumber}
                      </td>
                      <td className="px-4 py-3 text-xs text-gray-600">
                        {task.segmentName || "N/A"}
                      </td>
                      {isGroupWorkSelected && (
                        <td className="px-4 py-3 text-xs text-gray-600">
                          {task.memberName || "-"}
                        </td>
                      )}
                      <td className="px-4 py-3 text-right text-xs font-bold text-gray-800">
                        {task.pieces}
                      </td>
                      {/* {isMasterSelected && (
                        <td className="px-4 py-3 text-[10px] text-gray-700 space-x-1">
                          {task.completionSteps?.fabric && (
                            <span className="inline-block rounded-full border border-green-200 bg-green-50 px-2 py-0.5 text-[9px]">
                              Fabric
                            </span>
                          )}
                          {task.completionSteps?.astar && (
                            <span className="inline-block rounded-full border border-blue-200 bg-blue-50 px-2 py-0.5 text-[9px]">
                              Astar
                            </span>
                          )}
                          {task.completionSteps?.embroidery && (
                            <span className="inline-block rounded-full border border-orange-200 bg-orange-50 px-2 py-0.5 text-[9px]">
                              Embroidery
                            </span>
                          )}
                        </td>
                      )} */}

                      {isMasterSelected && (
                        <td className="px-4 py-3 text-[10px] text-gray-700">

                          <div className="inline-flex flex-col gap-1">
                            {renderStepRow("Fabric", task.completionSteps?.fabric)}
                            {renderStepRow("Astar", task.completionSteps?.astar)}
                            {renderStepRow("Embroidery", task.completionSteps?.embroidery)}
                          </div>
                        </td>
                      )}


                      <td className="px-4 py-3 text-xs text-gray-500">
                        {formatIST(task.assignedAt)}
                      </td>
                      <td className="px-4 py-3 text-xs text-gray-500">
                        {formatIST(task.completedAt)}
                      </td>
                      <td className="px-4 py-3 text-center">
                        {getStatusBadge(task.workStatus)}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PieceWorkEmployeeDetail;

